export default "__VITE_ASSET__17de31d7__"